module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-power@2x.8a71b3d2.png";